import { Box, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { startOfDay, subDays } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AtCircularProgress } from '../../../components/AtCircularProgress';
import { ObjectiveSelect } from '../../../components/ObjectiveSelect';
import { FilterTags } from '../../../components/TagsAtentus/FilterTags';
import { useObjectivesList } from '../../../hooks/useObjectivesList';
import theme from '../../../theme';
import { HeatMapObjective } from './HeatMapObjective';
import { InfoHeatMapPopover } from './InfoHeatMapPopover';
import { SelectPeriod } from './SelectPeriodo';

export const defaultSelectDateRange = {
  startDate: startOfDay(subDays(new Date(), 6)),
  endDate: startOfDay(new Date()),
  key: 'selection',
};

export function HeatMapContainer() {
  const { t } = useTranslation();
  const { data: objetivos, isLoading } = useObjectivesList({
    fromStorage: true,
  });
  const [objetivoId, setObjetivoId] = React.useState('');
  const [globalStatePeriod, setGlobalStatePeriod] = React.useState(
    defaultSelectDateRange
  );
  const [selectedTags, setSelectedTags] = React.useState([]);
  const [filterTagsType, setFilterTagsType] = React.useState('OR');

  function changeGlobalPeriod(statePeriod) {
    setGlobalStatePeriod(statePeriod);
  }

  const objetivosFiltered = React.useMemo(() => {
    if (selectedTags.length === 0) {
      return objetivos;
    }
    return objetivos.filter((item) => {
      let tieneEtiquetas = true;
      const etiquetas = item.Etiquetas || [];
      if (filterTagsType === 'AND') {
        for (const id of selectedTags) {
          if (!etiquetas.find((et) => et.etiqueta_id === id)) {
            tieneEtiquetas = false;
            break;
          }
        }
      } else {
        tieneEtiquetas = etiquetas.some((etiqueta) =>
          selectedTags.includes(etiqueta.etiqueta_id)
        );
      }
      return tieneEtiquetas;
    });
  }, [selectedTags, objetivos, filterTagsType]);

  if (isLoading) {
    return (
      <AtCircularProgress
        message={(t && typeof t === 'function') ? (t('text.loading.objectives-list') || 'Cargando listado de objetivos') : 'Cargando listado de objetivos'}
      />
    );
  }

  function updateEtiquetas(etiquetas, filterType) {
    const tagsId = etiquetas.map((etiqueta) => etiqueta.etiqueta_id);
    setSelectedTags(tagsId);
    setFilterTagsType(filterType);
  }

  return (
    <Box style={{ backgroundColor: 'white', padding: theme.spacing(3) }}>
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
            <FilterTags
              tagsId={selectedTags}
              preload={true}
              updateEtiquetas={(etiqueta, filterType = 'OR') =>
                updateEtiquetas(etiqueta, filterType)
              }
              showFilterType={true}
              filterTagsType={filterTagsType}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
            <ObjectiveSelect
              objetivos={objetivosFiltered}
              objetivoId={objetivoId}
              setObjetivoId={(id) => setObjetivoId(id)}
              isLoading={isLoading}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
            <SelectPeriod
              changeGlobalPeriodFromParent={changeGlobalPeriod}
              defaultSelectDateRangeFromParent={defaultSelectDateRange}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
            <Box display="flex" justifyContent="flex-end">
              <InfoHeatMapPopover />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box marginTop={2}>
        {!objetivoId ? (
          <Alert severity="info">{ (t && typeof t === 'function') ? (t('heatmap.alert.select-objective') || 'Selecciona un objetivo') : 'Selecciona un objetivo' }</Alert>
        ) : (
          <HeatMapObjective
            objetivoId={objetivoId}
            periodo="c"
            globalStatePeriod={globalStatePeriod}
          />
        )}
      </Box>
    </Box>
  );
}
